module.exports = __webpack_public_path__ + "img/question13c3.59c089a6.png";